
import XInput from 'vux/src/components/x-input/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'
import DatetimeRange from 'vux/src/components/datetime-range/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'

import {fetch,promptMessage } from '@/api/dataHandling';
import {preBodydefault} from '../../../static/js/preventWXUp';
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

import wx from 'weixin-js-sdk';
import axios from 'axios';
import Vue from 'vue';
import {urlConfig} from '@/api/urlConfig';
import {getken} from '@/api/getToken';
import $ from 'jquery';
import {timeCJ,setTimeHtml} from '../../../static/js/calendarPanle.js'
Vue.use(ConfirmPlugin);
export default {
data(){
return{
paralyticSiteShow:false,
submitdisabled:false,
injectNumShow:false,
injectNum:1,
hospital:'',
date:'',
projectreadonly:true,
maxterm:'',
time:'',
paralyticSite:'',
hospitalOptions: [],
maxtermOptions: [],
itemid:''
}
},
components: {
XInput,XNumber,Flexbox, FlexboxItem,Cell,dateFormat,XHeader,Group, PopupRadio,DatetimeRange, Datetime,XButton
},
watch:{

},
methods:{
getlocations(hos){
var _this = this;
axios.get('http://front.wh.jinxin-fertility.com/weixin/getsigninfo?url=' + encodeURIComponent(window.location.href)+'&openid='+this.$route.query.openid
).then(response => {

this.weixindata = response.data;
wx.config({
debug: false,
appId: _this.weixindata.appId,
timestamp: _this.weixindata.timestamp,
nonceStr: _this.weixindata.noncestr,
signature: _this.weixindata.signature,
jsApiList: ['checkJsApi', 'openLocation', 'getLocation']
});
}).catch(function (error) {
promptMessage('获取appid失败: ' +error);

})
var _this = this;
wx.ready(function () {
wx.checkJsApi({
jsApiList: ['getLocation'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
success: function(res) {

}
});
wx.getLocation({
type:'wgs84',
fail:function (erorr) {

},
success:function(res){
var latitude = res.latitude; 
var longitude = res.longitude; 
function toRad(d) {  return d * Math.PI / 180; }
_this.hosArry = [];
for(let i =0;i<hos.length;i++){
hos[i]['location'] = hos[i]['location'].split(',');
hos[i]['distance'] = _this.getDisance(latitude,longitude, hos[i]['location'][0], hos[i]['location'][1]);
_this.hosArry.push(_this.getDisance(latitude,longitude, hos[i]['location'][0], hos[i]['location'][1]));
}
_this.hosArry.sort(function (a, b) {
return a-b;
});
for(let i =0;i<hos.length;i++){
if(_this.hosArry[0] ==hos[i].distance){
_this.hospital = hos[i]['areaId'];
}
}
_this.$store.commit('updateLoadingStatus',{isLoading:false});
}
});


});
},
getDisance(lat1, lng1, lat2, lng2) {//lat为纬度, lng为经度, 一定不要弄错
var dis = 0;
var radLat1 = this.toRad(lat1);
var radLat2 = this.toRad(lat2);
var deltaLat = radLat1 - radLat2;
var deltaLng = this.toRad(lng1) - this.toRad(lng2);
var dis = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(deltaLat / 2), 2) + Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(deltaLng / 2), 2)));
return parseInt(dis * 6378137);
},
toRad(d) {
return d * Math.PI / 180;
},
maxtermChooseClick(obj,txt){
if(txt == '院区'){
if(this.hospital == ""){
this.projectreadonly = true;
}else {
this.projectreadonly = false;
}
}
if(this[obj] == ""){
promptMessage('提示','请选择'+txt);
}

},
projectChoose(){
this.time = '';
this.date = '';
if(this.maxterm !=""){
if(this.maxterm =="ff80808169988ceb01699de1671c51b4"){
this.injectNumShow = true;
}else {
this.injectNumShow = false;
}
if(this.maxterm =="2c9279a86e15c687016e1f3291bf5ba3"){  //如果是男科义诊
this.paralyticSiteShow = true;
timeCJ('time','date',this,this.getdateMthod(),10,1);
if(this.date == ''){
this.date = dateFormat((new Date()/1000+86400)*1000, 'YYYY-MM-DD');
}
}else {
this.paralyticSiteShow = false;
timeCJ('time','date',this,this.getdateMthod());
if(this.date == ''){
this.date = dateFormat(new Date(), 'YYYY-MM-DD');
}
}
$('.mask-time, .time-area').show();


/*   console.log(this.date,4444444444)
this.getdateMthod()();*/
}

},
hospitalChoose(){
this.maxtermOptions = [];
this.$store.commit('updateLoadingStatus',{isLoading:true});
this.maxterm = "";
this.date = "";
this.time = "";
if(this.hospital !=''){
if(this.hospital == ""){
this.projectreadonly = true;
}else {
this.projectreadonly = false;
}
if(this.$route.query.itemid == 'ff80808183c5a6ac0183c627bfdd00c9'){  // 宫颈疫苗
fetch('get',urlConfig.reservationyimiao+'?largeItemId='+ this.$route.query.itemid).then(response => {
console.log(response,5555)
this.itemid = this.$route.query.itemid;
this.maxtermOptions=[];
for(let i =0;i<response.length;i++){
this.maxtermOptions.push({
parentId:this.$route.query.itemid,
key:response[i].ITEMID,
value:response[i].ITEMNAME
})
}
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {

})
}else {
fetch('get', urlConfig.reservationGeneralProject + '?hospitalId=' + this.hospital + '&personInfoId=' + this.personInfoId).then(response => {
this.maxtermOptions = response;
for (let i = 0; i < response.length; i++) {
this.maxtermOptions[i].key = response[i].id;
this.maxtermOptions[i].value = response[i].itemMane;
}
this.$store.commit('updateLoadingStatus', {isLoading: false});
}).catch(error => {

})
}
}
},  //获取项目
getData(){
fetch('get',urlConfig.getHospitalMsg).then(response => {
for(let i =0;i<response.length;i++){
this.hospitalOptions.push({key:response[i].areaId,value:response[i].areaName});
}
this.$store.commit('updateLoadingStatus',{isLoading:false});
this.getlocations(response);
}).catch(error => {

})
},
getdateMthod(){
let _this = this;
return function(){
_this.$store.commit('updateLoadingStatus',{isLoading:true});
fetch('get',urlConfig.reservationGeneralDatetimes+'?scheduleDate='+ _this.date +'&itemId='+_this.maxterm).then(response => {
let timesArry = [];
for(let i=0;i<response.length;i++){
timesArry.push({key:response[i].id,value:response[i].shiftTime})
}
setTimeHtml(timesArry,'time',_this);
_this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {
let timesArry = [];
setTimeHtml(timesArry,'time',_this);
})
}

},   //获取时间段
dateonChange(){
if(this.maxterm !=""){
$('.mask-time, .time-area').show();
}else {
promptMessage('提示','请选择要预约的项目！');
}
}, //日期选择
cancel(){
const _this = this 
this.$vux.confirm.show({
title: '提示',
content: '取消当前预约？',
cancelText:'不，再考虑一下',
onConfirm () {
_this.parmdata = new URLSearchParams();
_this.parmdata.append('id',_this.itemMu.id);
fetch('post',urlConfig.reservationGeneralCancel,_this.parmdata).then(response => {
promptMessage('提示','取消成功！');
_this.$router.push({path:'/reservationIndex?openid='+this.$route.query.openid,query:{tabindex:1,leftTabIndex:3}});
}).catch(error => {

})
}  //确认
})
},//取消预约
submint(){

if(this.hospital !='' && this.maxterm !='' && this.date !='' && this.time !=''){
this.submitdisabled = true;
this.parmaData = new URLSearchParams();
let index = this.time.indexOf('(');
this.parmaData.append('personInfoId',this.personInfoId);
this.parmaData.append('scheduleDate',this.date);
this.parmaData.append('shiftTime',this.time.substring(0,index));
this.parmaData.append('shiftTimeId',this.timeStepId);
if(this.maxterm =="ff80808169988ceb01699de1671c51b4"){
this.parmaData.append('injectNum',this.injectNum);
}else {
this.parmaData.append('injectNum',0);
}
if(this.maxterm =="2c9279a86e15c687016e1f3291bf5ba3"){  //如果是男科义诊
if(this.paralyticSite.trim()){
this.parmaData.append('remark',this.paralyticSite);
}else{
promptMessage('提示','请输入瘫痪部位！');
this.submitdisabled = false;
return false;
}
}else{
this.parmaData.append('remark','');
}
for(let i=0;i<this.maxtermOptions.length;i++){
if(this.maxterm == this.maxtermOptions[i].key){
console.log(this.maxtermOptions[i],34)
if(this.maxtermOptions[i].parentId == null){ //大项
this.parmaData.append('orderLargeClassDm',this.maxtermOptions[i].key);
this.parmaData.append('orderLargeClassName',this.maxtermOptions[i].value);
}else { //小项
this.parmaData.append('orderLargeClassDm',this.maxtermOptions[i].parentId);
this.parmaData.append('orderSmallClassDm',this.maxtermOptions[i].key);
this.parmaData.append('orderSmallClassName',this.maxtermOptions[i].value);

}
}
}
let _this = this;
this.parmaData.append('scheduleSource',"微信通用预约");
console.log("param:"+this.parmaData);
fetch('post',urlConfig.reservationGeneralSave,this.parmaData).then(response => {
promptMessage('提示','保存成功！',function(){
_this.$router.push({path:'/reservationIndex?openid='+_this.openid,query:{tabindex:1,personInfoId:_this.personInfoId,type:'qt'}});
});
}).catch(error => {
this.submitdisabled = false;
})
}else {
promptMessage('提示','还有选项未选择！');
}
},
getUrlParam (name) {
var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
let url = location.href;
let search = url.split('?')[1]
if (search) {
var r = search.substr(0).match(reg)
if (r !== null) return decodeURI(r[2])
return null
} else {
return null
}
},
getUserId(){

this.$store.commit('updateLoadingStatus',{isLoading:true});
fetch('get',urlConfig.GetSfzh + '?openid='+this.openid).then(response => {
this.getPersonInfoId(response.sfzh);
}).catch(error => {

})
},
getPersonInfoId(sfzh){

fetch('get',urlConfig.GetPersonInfoId + '?sfzh='+sfzh).then(response => {
this.personInfoId = response.personInfoId;
this.getData();
}).catch(error => {

})

},
getopenid(code){
let cutton = location.href.split('?')[0];
axios.get(urlConfig.getweixinOpenid +  code).then(response => {
if(response.data.resultCode == 'success'){
if(response.data.openid.trim() !=''){
this.openid = response.data.openid;
getken(this.getUserId);
}else{
let parmasquery = '?bb=1';
for(let i in this.$route.query){
if(i != 'code' && i != 'bb' ){
parmasquery = parmasquery +'&' + i + '=' + this.$route.query[i];

}
}
window.location.href = cutton+parmasquery+'&time='+((new Date()).getTime());
}
}else{
let parmasquery = '?bb=1';
for(let i in this.$route.query){
if(i != 'code' && i != 'bb' ){
parmasquery = parmasquery +'&' + i + '=' + this.$route.query[i];

}
}
window.location.href = cutton+parmasquery+'&time='+((new Date()).getTime());
}

}).catch(function (error) {
promptMessage('提示' +error)
this.submitdisabled = true;
this.$store.commit('updateLoadingStatus',{isLoading:true});

});
},

},
mounted(){
let _this = this;

this.$store.commit('updateLoadingStatus',{isLoading:true});
if(this.$route.query.personInfoId){
this.personInfoId = this.$route.query.personInfoId;
this.openid = this.$route.query.openid;
getken(this.getData);
}else{

axios.get(urlConfig.getsigninfo + encodeURIComponent(window.location.href)
).then(response => {
this.weixindata = response.data;
const code = _this.getUrlParam('code');
if(!_this.$route.query.code){
var appid = response.data.appId;
var redirect_uri = encodeURIComponent(location.href);
if(code == null || code === ''){
window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=" + redirect_uri + "&response_type=code&scope=snsapi_base&state=1#wechat_redirect"
}
}else{

_this.getopenid(_this.$route.query.code)

}

}).catch(function (error) {
promptMessage('提示' +error)

});
}
$('.mask-time').height($(window).height());
$('.btn-choose-time').click(function() {
if (_this.time =='') {
promptMessage('提示','请选择就诊时间段!');
}else{  //确认选择按钮
_this.timeStepId = $('.time-table.choosed').attr('keyid');
$('.mask-time,.time-area').css("display", "none");
}
});
this.$nextTick(function(){
$('.inputClick').on('click',function(){
$(this).find('input').focus();
})
})
}
}



// WEBPACK FOOTER //
// ./src/project/MyReservationProject/reservationGeneral.vue